/** The setting that holds the id of the AI model used to generate filters from prompts. */
export const FilterAILlmSettingName = 'FilterAILlmId';
